module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orders"
  }, [_c('v-layout', _vm._b({}, 'v-layout', _vm.layout, false), [_c('v-flex', {
    attrs: {
      "md12": "",
      "lg8": ""
    }
  }, [_vm._l((_vm.orders), function(order, index) {
    return [_c('card', {
      attrs: {
        "order": order,
        "index": index
      }
    })]
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "hidden-md-and-down": ""
    }
  }, [(_vm.orders) ? _c('cart', {
    attrs: {
      "type": "items"
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ce1c015","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/index.vue
// module id = 781
// module chunks = 1